<template>
     <section id="hero">
          <v-img
               :min-height="minHeight"
               :src="require('@/assets/images/landscape-2278315_1920.jpg')"
               class="white--text"
               gradient="to right, rgba(5, 11, 31, .1), rgba(5, 11, 31, .6)"
          >
               <v-container class="fill-height px-4 py-12 justify-center">
                    <v-responsive
                         class="d-flex align-center"
                         height="100%"
                         max-width="60vw"
                    >
                         <base-heading
                              title="HOMEMADE JEWELRY CRAFTED WITH LOVE"
                              align="center"
                              class="hidden-sm-and-down"
                         />
                         <base-subheading
                              class="hidden-sm-and-down"
                              align="center"
                              title="Katinks Trinkets designs affordable homemade
                              jewelry.  Each piece is made with a connection to nature in mind. "
                         />
                         <base-subheading
                              class="hidden-md-and-up text-center"
                              align="center"
                              title="HOMEMADE JEWELRY CRAFTED WITH LOVE"
                         />
                         <base-body
                              class="hidden-md-and-up text-center"
                              align="center"
                         >
                              Katinks Trinkets designs affordable homemade
                              jewelry. Each piece is made with a connection to
                              nature in mind.
                         </base-body>

                         <div class="align-center text-center">
                              <base-btn
                                   href="https://www.etsy.com/shop/KatinksTrinkets"
                                   target="_blank"
                              >
                                   Discover More
                              </base-btn>
                         </div>
                    </v-responsive>
               </v-container>
          </v-img>
     </section>
</template>

<script>
export default {
     name: 'SectionHero',

     provide: {
          theme: { isDark: true },
     },

     computed: {
          minHeight() {
               const height = this.$vuetify.breakpoint.mdAndUp ? '90vh' : '50vh'

               return `calc(${height} - ${this.$vuetify.application.top}px)`
          },
     },
}
</script>
